var _rect, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDtDp1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "dtDP1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 75,
    viewBox: "0 0 74 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_155",
    "data-name": "Rectangle 155",
    width: 74,
    height: 75,
    rx: 6,
    fill: "#85deef"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "Transfer",
    transform: "translate(7.5 29.489)",
    fill: "#fff",
    fontSize: 15,
    fontFamily: "HelveticaNeue-Bold, Helvetica Neue",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Transfer"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    id: "DP_1",
    "data-name": "DP 1",
    transform: "translate(13.5 54.5)",
    fill: "#fff",
    fontSize: 20,
    fontFamily: "HelveticaNeue-Bold, Helvetica Neue",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "DP 1"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDtDp1);
export default __webpack_public_path__ + "static/media/dtDP1.8d46462b44ea4fa2bbe325aeee3139cf.svg";
export { ForwardRef as ReactComponent };